import { useCallback } from 'react';

import { ServiceWorker } from '@revelio/core';
import { Button } from '@revelio/ui';

import { useToast } from '../hooks/useToast';

const APP_UPDATE_TOAST_ID = 'app-update-available';

export const AppUpdateToast = () => {
  const toast = useToast();

  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  const handleUpdate = useCallback(() => {
    if (toast.isActive(APP_UPDATE_TOAST_ID)) {
      return;
    }

    toast({
      id: APP_UPDATE_TOAST_ID,
      title: 'New app version available',
      description: (
        <span>
          Click{' '}
          <Button
            color="lightBlue"
            size="xs"
            variant="link"
            onClick={handleReload}
          >
            here
          </Button>{' '}
          to refresh the page.
        </span>
      ),
      status: 'info',
      duration: null,
      position: 'top-right',
      isClosable: true,
    });
  }, [handleReload, toast]);

  return <ServiceWorker onUpdate={handleUpdate} />;
};
